<template>

  <div class="p-grid">

    <div class="p-col-12 p-mb-2">
      <Button label="Benutzer erstellen" icon="pi pi-plus" @click="openCreateUserDialog" class="p-button-success"/>
    </div>

    <!-- Data Table for normal devices -->
    <DataTable :value="users"
               selectionMode="single"
               class="p-d-none p-d-md-block"
               :selection.sync="selectedUser"
               @row-select="onRowSelect"
               :paginator="true"
               :rows="10">

      <template #empty>
        No customers found.
      </template>

      <template #loading>
        Loading customers data. Please wait.
      </template>

      <Column field="username" header="Benutzer">
        <template #body="slotProps">
          {{slotProps.data.username}}<br />
          <span v-if="slotProps.data.lastLoginTs != null" class="p-tag p-tag-info p-tag-sm p-p-1">Last Login: {{formatDate(slotProps.data.lastLoginTs)}}</span>
        </template>
      </Column>

      <Column field="name" header="Vorname"></Column>
      <Column field="surname" header="Nachname"></Column>
      <Column field="email" header="Email"></Column>

      <Column field="isActive" header="Active" headerStyle="width: 8rem; text-align: center"
              bodyStyle="text-align: center; overflow: visible">
        <template #body="slotProps">
          <InputSwitch v-model="slotProps.data.isActive"
                       :onchange="switchUserActivation(slotProps.data)"></InputSwitch>
        </template>
      </Column>

    </DataTable>

    <!-- Data Table for small devices -->
    <DataTable :value="users"
               selectionMode="single"
               class="p-datatable-sm p-d-md-none"
               :selection.sync="selectedUser"
               @row-select="onRowSelect"
               :paginator="true"
               :rows="10">

      <template #empty>
        No customers found.
      </template>

      <template #loading>
        Loading customers data. Please wait.
      </template>

      <Column field="username" header="Benutzer"></Column>
      <Column field="name" header="Vorname"></Column>
      <Column field="surname" header="Nachname"></Column>

      <Column field="isActive" header="Active" headerStyle="width: 8rem; text-align: center"
              bodyStyle="text-align: center; overflow: visible">
        <template #body="slotProps">
          <InputSwitch v-model="slotProps.data.isActive"
                       :onchange="switchUserActivation(slotProps.data)"></InputSwitch>
        </template>
      </Column>

    </DataTable>

    <Dialog header="Benutzerdaten ändern" :visible.sync="showEdit" :modal="true">
      <UserEdit @close-dialog="closeDialog" :selected-user-prop="selectedUser"></UserEdit>
    </Dialog>

    <Dialog header="Neuen Benutzer erstellen" :visible.sync="showCreateUser" :modal="true">
      <CreateUser @close-dialog="closeCreateUserDialog" @user-created="onUserCreated"></CreateUser>
    </Dialog>

  </div>

</template>

<script>
import AuthService from "../services/auth.service";
import UserService from "../services/user.service";
import UserEdit from "@/components/UserEdit";
import CreateUser from "@/components/CreateUser";
import moment from "moment";

export default {
  name: "user-list",
  components: {UserEdit, CreateUser},
  data() {
    return {
      users: [],
      selectedUser: null,
      currentUser: null,
      showEdit: false,
      showCreateUser: false,
      currentIndex: -1
    }
  },
  methods: {
    retrieveUser() {
      AuthService.getAllUser()
          .then(response => {
            // console.log(JSON.stringify(response.data));
            this.users = response.data
          })
          .catch(err => {
            console.log(err);
          });
    },
    formatDate(lastLoginTs){
      if(lastLoginTs == null) return "";
      return moment.utc(lastLoginTs).local().locale('de').format("DD.MM.YYYY HH:mm.ss");
    },
    refreshList() {
      this.retrieveUser();
      this.currentUser = null;
      this.currentIndex = -1;
    },
    onRowSelect() {
      // console.log("Row: " + event.data._id);
      // console.log("this.selectedUser: " + this.selectedUser);
      if (this.selectedUser !== null) {
        this.showEdit = true;
      }
    },
    closeDialog(){
      this.showEdit = false;
      this.refreshList();
    },
    openCreateUserDialog() {
      this.showCreateUser = true;
    },
    closeCreateUserDialog() {
      this.showCreateUser = false;
    },
    onUserCreated() {
      this.refreshList();
    },
    switchUserActivation(data) {
      UserService.switchActivation(data)
          .then(() => {
            // console.log(JSON.stringify(response.data));
            // this.users = response.data
          })
          .catch(err => {
            console.log(err);
          });
      // this.currentUser = user;
      // this.currentIndex = index;
    }
  },
  mounted() {
    this.retrieveUser();
  }
}
</script>

<style>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}
</style>